import Types from './Types';
import { requestXrefByVenueXids } from './xrefActions';

const rankSet = {
	TSXComposite: 'TSX Stocks',
	TSXV: 'TSX Venture Stocks',
	NYSE: 'NYSE Stocks',
	NASDAQ: 'NASDAQ Stocks',
	AMEX: 'NYSE American Stocks',
	USDJIA: 'DJIA Index',
	USCOMP: 'NASDAQ Stocks',
	USSPX: 'S&P 500 Index'
};

const rankType = {
	pctChgAsc: 'PctChgAsc',
	pctChgDesc: 'PctChgDesc',
	pctChgGainers: 'PctChgGainers',
	pctChgLosers: 'PctChgLosers',
	netGainers: 'NetGainers',
	netLosers: 'NetLosers',
	relativeVolume90D: 'RelativeVolume90D',
	volume: 'MostActive'
};

const receiveMarketRankings = (response, rankingType) => {
	let xids = [];

	if (response && response.data && response.data.marketRankings) {
		xids = response.data.marketRankings.map(item => item.venueXid);
	}

	const actions = [];

	if (xids.length > 0) {
		actions.push(requestXrefByVenueXids(xids));
	}

	actions.push({
		type: Types.API_RECEIVE_MARKET_RANKINGS,
		response,
		rankingType
	});

	return (actions);
};

const handleLoader = fetchName => {
	return ({
		type: Types.API_HANDLE_MARKET_RANKINGS_LOADER,
		fetchName
	});
};

const requestMarketRankings = (rankingSet, rankingType, count = 10, realtime = false) => {
	return {
		type: Types.API_REQUEST_MARKET_RANKINGS,
		endPoint: '/market-rankings/v1/detail',
		params: {
			rankingSet,
			rankingType,
			count
		},
		headers: {
			realtime
		},
		ajaxType: 'GET',
		onSuccess: response => { return receiveMarketRankings(response, rankingType); },
		loader: handleLoader,
		fetchName: 'fetchingMarketRankings'
	};
};

export {
	requestMarketRankings,
	receiveMarketRankings,
	rankType,
	rankSet
};
